export default {"src":"/_next/static/media/profile-details.01e0c62a.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};